























































































import { Component, Prop, Vue } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import { emptyToLine, splitThousands } from "@/utils/common";
import BtnRadio from "@/components/scope/btn-radio.vue";
import echarts from "echarts";
import dayjs from "dayjs";

const finance = namespace("finance");

@Component({
  components: { BtnRadio }
})
export default class ReportOutputValue extends Vue {
  @finance.Action getItemProductionValue;
  emptyToLine = emptyToLine;
  splitThousands = splitThousands;
  formData: any = {
    statisticMethod: "1",
    statisticDate: ""
  };
  myChart: any;
  nowDate: any = dayjs();
  mounted() {
    // 基于准备好的dom，初始化echarts实例
    this.$refs.outputPie && (this.myChart = echarts.init(this.$refs.outputPie));
  }
  created() {
    this.init();
    this.formData.statisticDate = this.nowDate.subtract(1, "d").format("YYYYMMDD");
  }
  init() {
    this.loadServerData();
  }
  draw(serverData?) {
    let nameArr = [];
    let valueArr = [];
    serverData.data.rankingList &&
      serverData.data.rankingList.forEach(item => {
        nameArr.push(item.serviceName);
        valueArr.push({
          name: item.serviceName,
          value: Number(item.productionValue)
        });
      });
    nameArr.push(this.$t("base.ohter"));
    if (serverData.data.other) {
      valueArr.push({
        name: this.$t("base.ohter"),
        value: Number(serverData.data.other.productionValue)
      });
    }
    let options = {
      tooltip: {
        trigger: "item",
        formatter: params => {
          console.log(params);
          return `${params.name}<br/>${this.$t("finance.item-output-value")}: ${this.$localMark.currencySymbol +
            splitThousands(params.value)}(${params.percent}%)`;
        }
        // formatter: `{b} <br/>${this.$t("finance.item-output-value")}: ${
        //   this.$localMark.currencySymbol
        // }{c} ({d}%)`
      },
      legend: [
        {
          icon: "rect ",
          x: "center",
          bottom: 160,
          itemWidth: 12,
          itemHeight: 12,
          itemGap: 20,
          data: nameArr.slice(0, 4)
        },
        {
          icon: "rect ",
          x: "center",
          bottom: 120,
          itemWidth: 12,
          itemHeight: 12,
          itemGap: 20,
          data: nameArr.slice(4, 8)
        },
        {
          icon: "rect ",
          x: "center",
          bottom: 80,
          itemWidth: 12,
          itemHeight: 12,
          itemGap: 20,
          data: nameArr.slice(8)
        }
      ],
      color: [
        "#2278F5",
        "#599AFA",
        "#00B478",
        "#5FC71A",
        "#FEBC00",
        "#FF9900",
        "#FE7000",
        "#F74E3B",
        "#E20568",
        "#8543E0",
        "#5D7092"
      ],
      graphic: [
        {
          //环形图中间添加文字
          type: "text", //通过不同top值可以设置上下显示
          left: "center",
          top: "25%",
          style: {
            text: this.$t("finance.item-output-value-currency"),
            textAlign: "center",
            fill: "rgba(0, 0, 0, 0.45)",
            width: 30,
            height: 30,
            fontSize: 20
          }
        },
        {
          //环形图中间添加文字
          type: "text", //通过不同top值可以设置上下显示
          left: "center",
          top: "30%",
          style: {
            text: splitThousands(serverData.data.totalProductionValue),
            textAlign: "center",
            width: 30,
            height: 30,
            fontSize: 20
          }
        }
      ],
      series: [
        {
          name: this.$t("finance.access-source"),
          type: "pie",
          radius: ["30%", "50%"],
          center: ["50%", "30%"],
          avoidLabelOverlap: false,
          label: {
            show: false
          },
          emphasis: {
            label: {
              show: false,
              fontSize: "30",
              fontWeight: "bold"
            }
          },
          labelLine: {
            show: false
          },
          data: valueArr
        }
      ]
    };
    // 绘制图表
    this.myChart.setOption(options);
  }
  handleDateChange() {
    this.loadServerData();
  }
  handleDateTypeChange() {
    if (this.formData.statisticMethod === "1") {
      this.formData.statisticDate = this.nowDate.subtract(1, "d").format("YYYYMMDD");
    } else {
      this.formData.statisticDate = this.nowDate.subtract(1, "M").format("YYYYMM");
    }
    this.loadServerData();
  }
  serverData: any = { data: { rankingList: [] } };
  loadServerData() {
    this.getItemProductionValue(this.formData).then(data => {
      console.log("data", data);
      this.serverData = data;
      data.data.rankingList.length && this.draw(data);
    });
  }
}
